// extracted by mini-css-extract-plugin
export default {"oosNotify":"e7-z","count":"f7-z","otherColors":"g7-z","modalContent":"h7-z","body":"i7-z"};